import './Card.scss'
import classnames from 'classnames'
import React from 'react'

// 卡片背景底色
export const Card = React.forwardRef((props, ref) => {
    return (
        <div className={classnames('card', props.className)} style={props.style} onScroll={props.onScroll} ref={ref}>
            {props.children}
        </div>
    )
})
